import type { BetslipLabels } from "@/features/fu-widgets/library-types";
import type { Labels } from "@/lib/labels/types";
import type { TenantBetslipConfig } from "@/lib/tenant/TenantSettingsProvider";

/**
 * Compose a `BetslipLabels` object from canvas labels + tenant config.
 * Only keys we actively translate on the canvas side are included; where
 * our labels and the library defaults agree, the field is omitted so the
 * library picks its own translation for the active language.
 */
export function mapCanvasLabels(labels: Labels, betslipConfig: TenantBetslipConfig): BetslipLabels {
    const b = labels.betslip;
    const matchOdds = labels.matchPage.odds;

    return {
        // Tenant CTA label wins if set, otherwise fall back to canvas translation.
        placeBetLabel: betslipConfig.ctaLabel || b.placeBet,
        title: b.title,
        emptyTitle: b.emptyTitle,
        emptyDescription: b.emptyDescription,
        continueLabel: b.continueLabel,
        disclaimer: b.disclaimer,
        combinedOddsLabel: b.combinedOdds,
        stakeLabel: b.stake,
        totalStakeLabel: b.totalStake,
        potentialWinLabel: b.potentialWin,
        oddsUnavailableLabel: b.oddsUnavailable,
        suspendedLabel: b.suspended,
        outcomeLabels: {
            yes: matchOdds.selectionsBtts.yes,
            no: matchOdds.selectionsBtts.no,
            draw: labels.predictorPage.odds.draw,
        },
    };
}
